import { TrianglePosition } from './types';
import { TriangleResolution } from '../types';
import { DIRECTIONS, POSITIONS } from './constants';

/**
 * Draws triangles at the edges of a rectangle
 */
export function drawTriangles(
  ctx: CanvasRenderingContext2D,
  triangleResolution: TriangleResolution,
  x: number,
  y: number,
  width: number,
  height: number,
  color: string
): void {
  ctx.fillStyle = color;

  const rightX = x + width;
  const bottomY = y + height;
  const centerX = x + width / 2;
  const centerY = y + height / 2;

  const positions: TrianglePosition[] = [
    // Top triangles
    { x: centerX, y, direction: DIRECTIONS.UP },
    {
      x: x + width * POSITIONS.TOP_EDGE,
      y,
      direction: DIRECTIONS.UP,
    },
    {
      x: x + width * POSITIONS.BOTTOM_EDGE,
      y,
      direction: DIRECTIONS.UP,
    },

    // Bottom triangles
    {
      x: centerX,
      y: bottomY,
      direction: DIRECTIONS.DOWN,
    },
    {
      x: x + width * POSITIONS.TOP_EDGE,
      y: bottomY,
      direction: DIRECTIONS.DOWN,
    },
    {
      x: x + width * POSITIONS.BOTTOM_EDGE,
      y: bottomY,
      direction: DIRECTIONS.DOWN,
    },

    // Left triangles
    {
      x,
      y: centerY,
      direction: DIRECTIONS.LEFT,
    },
    {
      x,
      y: y + height * POSITIONS.TOP_EDGE,
      direction: DIRECTIONS.LEFT,
    },
    {
      x,
      y: y + height * POSITIONS.BOTTOM_EDGE,
      direction: DIRECTIONS.LEFT,
    },

    // Right triangles
    {
      x: rightX,
      y: centerY,
      direction: DIRECTIONS.RIGHT,
    },
    {
      x: rightX,
      y: y + height * POSITIONS.TOP_EDGE,
      direction: DIRECTIONS.RIGHT,
    },
    {
      x: rightX,
      y: y + height * POSITIONS.BOTTOM_EDGE,
      direction: DIRECTIONS.RIGHT,
    },
  ];

  // Draw all triangles
  positions.forEach((pos) => {
    drawTriangle(
      ctx,
      triangleResolution,
      pos.x,
      pos.y,
      pos.direction,
      color
    );
  });
}

/**
 * Draws a single triangle
 * @param direction - 0=up, 1=left, 2=down, 3=right
 */
function drawTriangle(
  ctx: CanvasRenderingContext2D,
  triangleResolution: TriangleResolution,
  x: number,
  y: number,
  direction: number,
  color: string
): void {
  ctx.fillStyle = color;
  ctx.beginPath();

  if (direction === DIRECTIONS.UP || direction === DIRECTIONS.DOWN) {
    // UP/DOWN triangles: use vertical resolution
    const { width: w, height: h } = triangleResolution.vertical;

    if (direction === DIRECTIONS.UP) {
      ctx.moveTo(x, y);
      ctx.lineTo(x - w, y + h);
      ctx.lineTo(x + w, y + h);
    } else {
      ctx.moveTo(x, y);
      ctx.lineTo(x - w, y - h);
      ctx.lineTo(x + w, y - h);
    }
  } else {
    // LEFT/RIGHT triangles: use horizontal resolution
    const { width: w, height: h } = triangleResolution.horizontal;

    if (direction === DIRECTIONS.LEFT) {
      ctx.moveTo(x, y);
      ctx.lineTo(x + w, y - h);
      ctx.lineTo(x + w, y + h);
    } else {
      ctx.moveTo(x, y);
      ctx.lineTo(x - w, y - h);
      ctx.lineTo(x - w, y + h);
    }
  }

  ctx.closePath();
  ctx.fill();
}
